export default __webpack_public_path__ + "static/media/hager-logo.252be811.png";